import AdminFinishedEventsList from "./containers/finished-events";
import AdminDeletedEventsList from "./containers/deleted-events";
import AdminCancelledEventsList from "./containers/cancelled-events";
import AdminRescheduledEventsList from "./containers/rescheduled-events";
import AdminLiveAndUpcomingEventsList from "./containers/live-and-upcoming-events";
import OrganizersEdit from "./containers/organizers-edit";
import OrganizersList from "./containers/organizers-list";
import TmtEventEdit from "./containers/tmt-event-edit";
import AdminTmtEventsList from "./containers/tmt-events-list";
import PrimaryAdminPanel from "./primaryAdminPanel";
import RedirectToEvents from "./redirect";

export {
  PrimaryAdminPanel,
  RedirectToEvents,
  AdminTmtEventsList,
  TmtEventEdit,
  OrganizersList,
  OrganizersEdit,
  AdminFinishedEventsList,
  AdminDeletedEventsList,
  AdminCancelledEventsList,
  AdminRescheduledEventsList,
  AdminLiveAndUpcomingEventsList,
};
